/**
 * @description Can be swapped with the primary gray color.
 */

const grayModern = {
  25: "#FCFCFD",
  50: "#F8FAFC",
  100: "#EEF2F6",
  200: "#E3E8EF",
  300: "#CDD5DF",
  400: "#9AA4B2",
  500: "#697586",
  600: "#4B5565",
  700: "#364152",
  800: "#202939",
  900: "#121926",
  950: "#0D121C",
};

export default grayModern;
